import { useCallback, useState, type MouseEvent, type ReactNode } from "react";
import { IconMore } from "./icons";
import { ToolPopover } from "./ToolPopover";

/**
 * Paginakop: label, titel, rechts hooguit één primaire actie en eventueel een ⋯-menu,
 * daaronder tabs over de volle breedte. Filters horen onder de kop, in de pagina zelf.
 */
export function PageHeader({
  label,
  title,
  action,
  menu,
  menuLabel = "Meer acties",
  tabs,
}: {
  label: ReactNode;
  title: ReactNode;
  /** De primaire actie (`btn primary`). */
  action?: ReactNode;
  /** Knoppen en links in het ⋯-menu (`menuitem`); een keuze sluit het menu. */
  menu?: ReactNode;
  menuLabel?: string;
  tabs?: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const onOpenChange = useCallback((v: boolean) => setOpen(v), []);
  // Na de klik sluiten (niet ervoor): een downloadlink moet nog in de pagina staan als de browser hem volgt.
  const closeOnPick = (e: MouseEvent) => {
    if ((e.target as HTMLElement).closest("button, a")) setTimeout(() => setOpen(false));
  };
  return (
    <header className="pagehead">
      <p className="label">{label}</p>
      <div className="titlerow">
        {/* Geen extra punt achter een naam die al op een punt eindigt (B.V.). */}
        <h1 className={typeof title === "string" && title.endsWith(".") ? undefined : "dot"}>{title}</h1>
        {(action || menu) && (
          <span className="pageactions">
            {action}
            {menu && (
              <ToolPopover
                label={menuLabel}
                title={menuLabel}
                icon={<IconMore size={20} aria-hidden="true" />}
                hideLabel
                open={open}
                onOpenChange={onOpenChange}
              >
                <div className="pagemenu" onClick={closeOnPick}>
                  {menu}
                </div>
              </ToolPopover>
            )}
          </span>
        )}
      </div>
      {tabs}
    </header>
  );
}
